import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LangInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the current language from local storage or a service
    const currentLang = localStorage.getItem('lang') || 'fr';
    // Clone the request and add the `lang` header
    const modifiedRequest = request.clone({
      setHeaders: {
        'Accept-Language': currentLang
      }
    });

    return next.handle(modifiedRequest);
  }
}
